import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { orpc } from '@/api/rpc/client';
// fallow-ignore-next-line circular-dependency
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requireAnyPermission, requireModules } from '../../route';
import { settleLookup, viewRuleSetCrumbs } from './exceptionRuleSetCrumbs';

const ExceptionRuleSetViewPage = lazyRouteComponent(
  () => import('./ExceptionRuleSetViewPage'),
  'ExceptionRuleSetViewPage',
);

function ViewExceptionRuleSetRoutePage() {
  const { ruleSetId } = Route.useParams();
  return <ExceptionRuleSetViewPage ruleSetId={ruleSetId} routeId={Route.id} />;
}

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/exception-rules/$ruleSetId',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.APExceptionRuleSet },
        ],
      },
    },
  },
  component: ViewExceptionRuleSetRoutePage,
  loader: async ({ params, context }) => {
    const ruleSet = await settleLookup(
      context.queryClient.fetchQuery(
        orpc.accountsPayable.exceptionRuleSets.get.queryOptions({
          input: { id: params.ruleSetId },
        }),
      ),
    );
    return viewRuleSetCrumbs(ruleSet?.name);
  },
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Read, subject: Subject.APExceptionRuleSet },
      ],
    });
  },
});
